import { createApp } from 'vue';
import TtcToTtfConverter from '@/Components/TtcToTtfConverter.vue';
import '@styles/app.css';

createApp(TtcToTtfConverter).mount('#ttc-to-ttf-converter');
